export const defaultMenuType = 'menu-default';
export const subHiddenBreakpoint = 1440;
export const menuHiddenBreakpoint = 768;
export const defaultLocale = 'en';
export const localeOptions = [
  {
    id: 'en',
    name: 'English - LTR',
    direction: 'ltr',
  },
  {
    id: 'es',
    name: 'Español',
    direction: 'ltr',
  },
  {
    id: 'enrtl',
    name: 'English - RTL',
    direction: 'rtl',
  },
];

export const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: 'hubbers-hub-of-makers-167507.firebaseapp.com',
  databaseURL: 'https://hubbers-hub-of-makers-167507.firebaseio.com',
  projectId: 'hubbers-hub-of-makers-167507',
  storageBucket: 'hubbers-hub-of-makers-167507.appspot.com',
  messagingSenderId: '174996643158',
  appId: '1:174996643158:web:2850c36f63bb6971f9caf7',
  measurementId: 'G-DHFDSP43Z3',
};

export const adminRoot = '/app';
export const buyUrl = 'https://1.envato.market/k4z0';
export const searchPath = `${adminRoot}/#`;
export const servicePath = 'https://api.coloredstrategies.com';

export const themeColorStorageKey = '__theme_selected_color';
export const isMultiColorActive = true;
export const defaultColor = 'light.purplemonster';
export const isDarkSwitchActive = true;
export const defaultDirection = 'ltr';
export const themeRadiusStorageKey = '__theme_radius';
export const isAuthGuardActive = true;
export const colors = [
  'bluenavy',
  'blueyale',
  'blueolympic',
  'greenmoss',
  'greenlime',
  'purplemonster',
  'orangecarrot',
  'redruby',
  'yellowgranola',
  'greysteel',
];
/* eslint-disable */
